import {pageInfo,startRecheck} from '../api';
import {Message} from 'element-ui';
import {goodsCategory, plant, deviceQc} from "../../../../../api";

const recheck = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    recheckObj: null,
    deviceQcObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    GOODS_CATEGORY(state, data) {
      state.goodsCategoryObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    RECHECK(state, data){
      state.recheckObj = data;
    },
    DEVICE_QC(state, data) {
      state.deviceQcObj = data.obj;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async goodsCategory({commit}, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async recheck({commit}, obj){
      let result = await startRecheck(obj);
      commit('RECHECK', result);
    },
    async deviceQc({commit}, obj) {
      let resp = await deviceQc(obj);
      commit('DEVICE_QC', resp);
    },
  }
}
export default recheck



// WEBPACK FOOTER //
// ./src/page/bd/qc/recheck/store/recheck.store.js